import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const TimeSheetStyled = styled.div`
  height: auto;
  /* background-color: #e6d8e9; */
  padding-bottom: 10px;

  input {
    border: none !important;
    font-size: 16px;
  }

  fieldset {
    border: none !important;
  }
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
    max-width: 350px !important;
  }

  .timeInput {
    margin: 0;

    input {
      color: var(--flow-30-neutral-1, #080425);
      text-align: center;
      font-size: 14px;
    }
  }

  .edited {
    color: red !important;
  }

  .header {
    padding: 3px 36px 10px 36px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};

    .date-wrap {
      display: flex;
      .left {
        background-color: white;
        border: 1px solid #545f71;
        border-radius: 4px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px 5px;
      }
      .right {
        border-radius: 4px;
        background-color: white;
        border: 1px solid #545f71;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px 8px;
        cursor: pointer;
        background-color: ${COLOUR_CONSTANT.theme.purple.light};
      }
    }

    .buttons-wrap {
      display: flex;
      .left {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        background-color: ${COLOUR_CONSTANT.theme.purple.light};
        border-right: none;
      }
      .right {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        gap: 25px;
        background-color: ${COLOUR_CONSTANT.theme.purple.light};
      }

      button {
        width: 100px;
        color: #301d35;
        background-color: white;
        border: 1px solid #301d35;
        font-weight: bold;
        svg {
          color: #301d35;
        }
      }
    }
  }

  .table-wrap {
    padding: 15px 36px 10px 36px;

    .MuiTableFooter-root {
      position: sticky;
      inset-block-end: 0;
    }
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .total-text {
    font-size: 16px;
    color: #545f71;
    padding: 10px 0px;
  }
  .disabled-icon {
    /* pointer-events: none; */
    svg {
      cursor: not-allowed !important;
      color: #545f71 !important;
    }
  }
  .over-time-class {
    color: ${COLOUR_CONSTANT.theme.medium} !important;
  }

  .time-col-footer {
    height: 100%;
    color: #080425;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${COLOUR_CONSTANT.theme.background.dark};
  }
  .date-header {
    padding: 10px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .auto-complete {
    min-width: 420px;
    .MuiAutocomplete-root .MuiInputBase-root {
      border: none;
      background: white;
    }
  }
  .MuiTableContainer-root {
    max-height: 600px;
  }
  thead {
    tr {
    }
  }
  tbody {
    tr {
      & td:nth-child(1) {
        padding: 0px !important;
      }
      & td:nth-child(n + 3) {
        padding: 0px !important;
      }
    }
  }

  .project-cell {
    padding-right: 10px;
    display: flex;
    align-items: center;
    text-align: left;
    .icon-style {
      border-right: 2px solid ${COLOUR_CONSTANT.theme.purple.medium};
      padding: 3px 0px;
      margin-right: 7px;

      button {
        padding: 0 !important;
      }
    }
  }

  .select-style {
    cursor: pointer;
    width: 200px;
  }

  .purple-background {
    .MuiInputBase-root {
      /* background-color: rgb(239, 237, 253); */
    }
  }

  .white-background {
    .MuiInputBase-root {
      background-color: rgb(239, 237, 253);
    }
  }

  .time-value-class {
    height: 60px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
  }

  .totals-style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .edit-option {
    width: 93%;
    display: flex;
    justify-content: center;
    background-color: ${COLOUR_CONSTANT.theme.purple.dark};
    min-height: 10px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

    &:hover {
      .hide {
        display: block !important;
      }
    }
    .hide {
      display: none;
    }

    cursor: pointer;
    svg {
      color: black;
      cursor: pointer;
    }
  }

  .role-footer {
    text-align: right;
    margin-right: 16px;

    .text-style {
      font-weight: bold;
      color: #fff !important;
    }
  }
`;
